import React from 'react';

/**
 * 시작하기 섹션 컴포넌트
 */
function GettingStartedSection() {
  return (
    <section id="getting-started" className="guide-section">
      <h2>🚀 시작하기</h2>
      
      <div className="section-intro">
        <p>PW-Wallet을 처음 사용하시나요? 차근차근 따라해보세요!</p>
      </div>

      <div className="step-cards">
        <div className="step-card">
          <div className="step-number">1</div>
          <div className="step-content">
            <h3>Google 계정으로 로그인</h3>
            <p>안전한 Google OAuth 인증으로 간편하게 시작하세요.</p>
            <div className="step-detail">
              <code>🔗 "Google로 로그인" 버튼 클릭</code>
              <ul>
                <li>✅ Google 계정 선택</li>
                <li>✅ 권한 승인</li>
                <li>✅ 자동으로 대시보드 이동</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="step-card">
          <div className="step-number">2</div>
          <div className="step-content">
            <h3>첫 번째 패스워드 추가</h3>
            <p>대시보드에서 첫 패스워드를 안전하게 저장해보세요.</p>
            <div className="step-detail">
              <code>➕ "새 패스워드" 버튼 클릭</code>
              <ul>
                <li>📝 제목 입력 (예: Google)</li>
                <li>🌐 웹사이트 URL</li>
                <li>👤 사용자명/이메일</li>
                <li>🔐 패스워드 (🎲로 생성 가능)</li>
                <li>🏷️ 태그 (선택사항)</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="step-card">
          <div className="step-number">3</div>
          <div className="step-content">
            <h3>안전성 확인</h3>
            <p>패스워드가 안전하게 암호화되어 저장되었는지 확인하세요.</p>
            <div className="step-detail">
              <code>🛡️ 보안 권장사항 확인</code>
              <ul>
                <li>💪 패스워드 강도 분석</li>
                <li>🔄 중복 패스워드 감지</li>
                <li>📊 보안 등급 확인</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default GettingStartedSection;